import { render, staticRenderFns } from "./EventStatus.vue?vue&type=template&id=fa2fcd32&scoped=true&"
import script from "./EventStatus.vue?vue&type=script&lang=js&"
export * from "./EventStatus.vue?vue&type=script&lang=js&"
import style0 from "./EventStatus.vue?vue&type=style&index=0&id=fa2fcd32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2fcd32",
  null
  
)

export default component.exports